"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  gradient,
  ...props
}) => {
  const iconSharedUtils = require('./utils/icon-shared-utils');
  const hasGradient = iconSharedUtils.hasValidGradient(gradient);
  let fillValue = color;
  let gradientDefs;
  let gradientUtils;
  if (hasGradient) {
    gradientUtils = iconSharedUtils.getGradientUtils();
    const iconWebUtils = require('./utils/icon-web-utils');
    const gradientId = gradientUtils.generateGradientId(gradient);
    fillValue = `url(#${gradientId})`;
    gradientDefs = iconWebUtils.renderWebGradientDefs(gradient, gradientId);
  }
  const svgContent = (0, _jsxRuntime.jsxs)("svg", {
    ...props,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: fillValue,
    role: title ? 'img' : undefined,
    "aria-hidden": !title,
    "aria-labelledby": titleId,
    children: [title ? (0, _jsxRuntime.jsx)("title", {
      id: titleId,
      children: title
    }) : null, (0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      d: "M19.23 19.18c-.889 0-1.61-.739-1.61-1.65 0-.912.721-1.651 1.61-1.651.888 0 1.608.739 1.608 1.651 0 .911-.72 1.65-1.608 1.65Zm-2.487-4.475c-.198 0-.36-.198-.36-.442 0-.245.162-.442.36-.442h.989c.198 0 .36.197.36.442 0 .244-.162.442-.36.442h-.989Zm-2.307-6.141a.418.418 0 0 1-.58-.135c-.004-.006-.023-.035-.054-.076-.701 1.69-2.44 3.24-5.056 3.24-2.667 0-4.516-1.624-5.112-3.325a.609.609 0 0 0-.048.101.42.42 0 0 1-.542.252.437.437 0 0 1-.246-.559c.182-.493.565-.826 1.11-.967.37-.093.69-.063.726-.06.23.024.4.237.373.476a.424.424 0 0 1-.46.385 1.42 1.42 0 0 0-.155-.002c.54 1.78 2.57 2.832 4.354 2.832 2.278 0 3.763-1.359 4.32-2.81a.621.621 0 0 0-.165.027.42.42 0 0 1-.528-.285.434.434 0 0 1 .277-.541c.491-.158.984-.053 1.426.301.301.242.474.519.493.549a.44.44 0 0 1-.133.597ZM4.779 19.18c-.89 0-1.61-.739-1.61-1.65 0-.912.72-1.651 1.61-1.651.888 0 1.608.739 1.608 1.651 0 .911-.72 1.65-1.608 1.65Zm18.573-6.031h-4.07c-.702 0-1.274-.587-1.274-1.308V9.88c0-.244.193-.442.43-.442.238 0 .431.198.431.442v1.96a.42.42 0 0 0 .414.425h2.613l-.86-3.702c-.209-.897-.99-1.53-1.888-1.53h-2.052v-2.1a.922.922 0 0 0-.91-.933H.91a.921.921 0 0 0-.91.933V16.91a.92.92 0 0 0 .909.933h1.494C2.553 19.058 3.553 20 4.778 20c1.224 0 2.224-.942 2.376-2.157h9.698C17.004 19.058 18.004 20 19.23 20c1.224 0 2.224-.942 2.376-2.157h1.744a.66.66 0 0 0 .65-.668v-3.359a.66.66 0 0 0-.648-.667Z",
      clipRule: "evenodd"
    })]
  });
  return hasGradient ? gradientUtils.addGradientToSvg(svgContent, gradientDefs) : svgContent;
};